<template>
		<module-tab name="发货记录" enable-flex @mounted="searchHandle" @activated="$refs.table.update()">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="发货单号">
					<c-input name="pack_number"></c-input>
				</m-search-item>
				<m-search-item label="订单编号">
					<c-input name="order_number"></c-input>
				</m-search-item>
				<m-search-item label="商品ID">
					<c-input name="product_id"></c-input>
				</m-search-item>
				<m-search-item label="商品标题">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="物流单号">
					<c-input name="logistics_number"></c-input>
				</m-search-item>
				<m-search-item label="发货时间" colspan="2">
					<c-datetime start-name="send_start_date" end-name="send_end_date" range></c-datetime>
				</m-search-item>
			</m-search>
			
			<c-table ref="table" height="grow">
				<c-table-column
					width="660"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货数"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="操作"
					width="130"
					align-center
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<span class="number">发货单号：{{data.pack_number}}</span>
								<p class="info">订单号：{{data.order_number}}</p>
								<p class="info">发货时间：{{data.send_date}}</p>
								<p class="info">发货人：{{data.user_realname}}</p>
							</div>
						</div>
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<span class="number">收货信息：{{data.receiving_name}},{{data.receiving_phone}},{{data.receiving_address}}</span>
								<p class="info">物流公司：{{data.logistics_company}}</p>
								<p class="info">物流单号：{{data.logistics_number}}</p>
							</div>
						</div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
                                            <p class="sku-sku"><span style="color: darkgray">规格：</span>{{sku.product_sku_spec}}</p>
                                            <p class="sku-sku" v-if="sku.product_sku_code"><span style="color: darkgray">SKU编码：</span>{{sku.product_sku_code}}</p>
										</div>
									</div>
									<div class="sku-count">{{sku.send_count}}</div>
								</div>
							</div>
							<div class="order-state flex-column flex-center">
								<a @click="navigateTo(`/order_wait_delivery_detail/${data.order_number}`)">订单详情</a>
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module-tab>
</template>

<script>
	export default {
		props: {
			tab: String
		},
		
		data() {
			return {
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				}
			}
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/order/delivery_detail_list',
					data: data
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		box-sizing: border-box;
		min-width: 920px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 790;
			flex-basis: 790px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 660;
					flex-basis: 660px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 130;
			flex-basis: 130px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
